<div class="grid grid-cols-1 sm:grid-cols-3 xl:grid-cols-5 gap-4">
  <mat-card class="card p-4">
    <div class="flex items-center justify-between mb-2">
      <span class="text-ui-gray-550">Opened incidents</span>
      <avs-incident-severity-icon />
    </div>
    <span class="text-xl font-bold">{{ stats()?.total ?? 0 }}</span>
  </mat-card>

  <mat-card class="card p-4">
    <div class="flex items-center justify-between mb-2">
      <span class="text-ui-gray-550">Critical incidents</span>
      <avs-incident-severity-icon [severity]="eIncidentSeverity.CRITICAL" />
    </div>
    <span class="text-xl font-bold">{{ stats()?.critical ?? 0 }}</span>
  </mat-card>

  <mat-card class="card p-4">
    <div class="flex items-center justify-between mb-2">
      <span class="text-ui-gray-550">Major incidents</span>
      <avs-incident-severity-icon [severity]="eIncidentSeverity.MAJOR" />
    </div>
    <span class="text-xl font-bold">{{ stats()?.major ?? 0 }}</span>
  </mat-card>

  <mat-card class="card p-4">
    <div class="flex items-center justify-between mb-2">
      <span class="text-ui-gray-550">Minor incidents</span>
      <avs-incident-severity-icon [severity]="eIncidentSeverity.MINOR" />
    </div>
    <span class="text-xl font-bold">{{ stats()?.minor ?? 0 }}</span>
  </mat-card>

  @if (display().createdToday) {
    <mat-card class="card p-4">
      <div class="flex items-center justify-between mb-2">
        <span class="text-ui-gray-550">Created today</span>
        <div class="icon-calendar text-ui-gray-550"></div>
      </div>
      <span class="text-xl font-bold">{{ stats()?.createdToday ?? 0 }}</span>
    </mat-card>
  }

  @if (display().resolvedRatio) {
    <mat-card class="card p-4">
      <div class="flex items-center justify-between mb-2">
        <span class="text-ui-gray-550">Resolved Ratio</span>
        <div class="icon-CheckCircleRounded text-ui-gray-550"></div>
      </div>
      <span class="text-xl font-bold">{{ stats()?.resolvedRatio ?? 0 }}</span>
    </mat-card>
  }
</div>
